export class ReturnDDSDocument {
  serviceCode: string;
  internalComment: string;
  reason: string;
  requestType: string;
}
